export default __webpack_public_path__ + "6ce1a6a88b2d8d6a5d5d71fa373e1491.png";